import { useState } from 'react'
import { Dialog, DialogPanel } from '@headlessui/react'
import { FaBars } from "react-icons/fa6"
import { IoIosCloseCircle } from "react-icons/io"
import { Link } from 'react-router-dom'

export default function WebsiteNav() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    
    const navigation = [
        // { name: 'Admin Login', href: '/admin-login' },
        // { name: 'Super Admin', href: '/super-admin-login' },
        { name: 'Home', href: '/' },
        { name: 'About', href: '/' },
        { name: 'Contact', href: '/' },
        { name: 'Login', href: '/employee-login' },
    ]
    
    return (
        <header className="absolute inset-x-0 top-0 z-50 bg-transparent">
            <nav aria-label="Global" className="flex items-center justify-between p-6 lg:px-8">
                <div className="flex lg:flex-1 overflow-hidden">
                    <Link to="/" className="-m-1.5 p-1.5">
                        <span className="sr-only">xyleads</span>
                        <div className="text-2xl font-bold text-white">
                            xy<span className="bg-gradient-to-r from-yellow-300 to-white bg-clip-text text-transparent">leads</span>
                        </div>
                    </Link>
                </div>
                <div className="flex lg:hidden">
                    <button
                        type="button"
                        onClick={() => setMobileMenuOpen(true)}
                        className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-white hover:bg-white hover:bg-opacity-10 transition-colors"
                    >
                        <span className="sr-only">Open main menu</span>
                        <FaBars aria-hidden="true" className="size-6" />
                    </button>
                </div>
                <div className="hidden lg:flex lg:gap-x-8">
                    {navigation.map((item) => (
                        <Link
                            key={item.name}
                            to={item.href}
                            className="text-sm font-semibold text-white hover:text-yellow-300 transition-colors font-sans"
                        >
                            {item.name}
                        </Link>
                    ))}
                </div>
                <div className="hidden lg:flex lg:flex-1 lg:justify-end">
                    <Link to="/admin-login" className="text-sm font-semibold text-white hover:text-yellow-300 transition-colors font-sans">
                        Admin Login <span aria-hidden="true">&rarr;</span>
                    </Link>
                </div>
            </nav>
            <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
                <div className="fixed inset-0 z-50" />
                <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-gradient-to-br from-purple-600 to-blue-600 px-6 py-6 sm:max-w-sm backdrop-blur-md">
                    <div className="flex items-center justify-between">
                        <Link to="/" className="-m-1.5 p-1.5">
                            <span className="sr-only">xyleads</span>
                            <div className="text-xl font-bold text-white">
                                xy<span className="bg-gradient-to-r from-yellow-300 to-white bg-clip-text text-transparent">leads</span>
                            </div>
                        </Link>
                        <button
                            type="button"
                            onClick={() => setMobileMenuOpen(false)}
                            className="-m-2.5 rounded-md p-2.5 text-white hover:bg-white hover:bg-opacity-10 transition-colors"
                        >
                            <span className="sr-only">Close menu</span>
                            <IoIosCloseCircle aria-hidden="true" className="size-6" />
                        </button>
                    </div>
                    <div className="mt-6 flow-root">
                        <div className="-my-6 divide-y divide-white divide-opacity-20">
                            <div className="space-y-2 py-6">
                                {navigation.map((item) => (
                                    <Link
                                        key={item.name}
                                        to={item.href}
                                        className="-mx-3 block rounded-lg px-3 py-3 text-base font-semibold text-white hover:bg-white hover:bg-opacity-10 transition-colors font-sans"
                                        onClick={() => setMobileMenuOpen(false)}
                                    >
                                        {item.name}
                                    </Link>
                                ))}
                            </div>
                            <div className="py-6">
                                <Link
                                    to="/admin-login"
                                    className="-mx-3 block rounded-lg px-3 py-3 text-base font-semibold text-white hover:bg-white hover:bg-opacity-10 transition-colors font-sans"
                                    onClick={() => setMobileMenuOpen(false)}
                                >
                                   Admin Login
                                </Link>
                            </div>
                        </div>
                    </div>
                </DialogPanel>
            </Dialog>
        </header>
    )
}
